import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import FormFieldViewTextCopyWrapper from "components/FormFields/ViewText/CopyWrapper";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";

import { VcsAgentPoolView } from "../types";

type VcsAgentPoolDetailsDrawerProps = {
  vcsAgentPool: VcsAgentPoolView;
};

const VcsAgentPoolDetailsDrawer = createDrawer(
  ({ vcsAgentPool }: VcsAgentPoolDetailsDrawerProps) => {
    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>

        <DrawerBody gap="x-large">
          <FormFieldViewText label="Name" value={vcsAgentPool.name} />
          <FormFieldViewTextCopyWrapper value={vcsAgentPool.id}>
            <FormFieldViewText label="ID" value={vcsAgentPool.id} />
          </FormFieldViewTextCopyWrapper>
          {vcsAgentPool.description && (
            <DescriptionDetails description={vcsAgentPool.description} />
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showVcsAgentPoolDetailsDrawer = createDrawerTrigger(VcsAgentPoolDetailsDrawer);
